import { EZasadyVyplaty } from 'enums/isin/udaje/zasadyVyplaty';

const zasadyVyplatySelect = [
    {
        value: EZasadyVyplaty.VYNO,
        labelcz: 'ISIN_EMISE_KOLEKTIVNI_ZASADY_V'
    },
    {
        value: EZasadyVyplaty.RUST,
        labelcz: 'ISIN_EMISE_KOLEKTIVNI_ZASADY_A'
    },
    {
        value: EZasadyVyplaty.SMIS,
        labelcz: 'ISIN_EMISE_KOLEKTIVNI_ZASADY_S'
    }
];

export default zasadyVyplatySelect;
